export default class magicLine {
  constructor(menu, activeClass) {
    this.menu = menu
    if (!this.menu) {
      return
    }
    this.menu.classList.add('has-magic-line')
    var activeLink = this.menu.querySelector(`.${activeClass}`)
    this.active = activeLink && !activeLink.parentNode.classList.contains('primary') && activeLink.parentNode
    this.update = this.update.bind(this)

    if (!(this.line = this.menu.querySelector('.magic-line'))) {
      this.line = document.createElement('li')
      this.line.className = 'magic-line'
      this.update()
      this.menu.appendChild(this.line)
    }

    for (let item of this.menu.querySelectorAll('[class*=--nav-item--]:not(.primary)')) {
      item.addEventListener('mouseenter', e => {
        return this.update(e.target)
      })
      item.addEventListener('mouseleave', e => {
        return this.update()
      })
    }

    // window.addEventListener('resize', () => this.update())
    this.update()
  }

  update(el = this.active) {
    if (!el) {
      this.line.style.width = 0
      return
    }
    this.line.style.width = `${el.clientWidth || 0}px`
    this.line.style.transform = `translateX( ${el.offsetLeft || 0}px)`
    return
  }
}
